import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import {
  createStateSyncMiddleware,
  initMessageListener,
} from "redux-state-sync";

import { combineReducers, configureStore, Middleware } from "@reduxjs/toolkit";
import appSlice from "@slices/app.slice";
import bookingCalendarSlice from "@slices/bookingCalendar.slice";
import cookieConsentSlice from "@slices/cookieConsent.slice";
import dashboardSlice from "@slices/dashboard.slice";
import drawerSlice from "@slices/drawer.slice";
import userSlice from "@slices/user.slice";

import authSlice from "../slices/auth.slice";
import bookingSlice from "../slices/booking.slice";
import localSlice from "../slices/local.slice";
import modalSlice from "../slices/modal.slice";
import organisationSlice from "../slices/organisation.slice";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["local", "app"],
};

const persistedReducer = persistReducer(
  persistConfig,
  combineReducers({
    app: appSlice.reducer,
    auth: authSlice.reducer,
    booking: bookingSlice.reducer,
    bookingCalendar: bookingCalendarSlice.reducer,
    cookieConsent: cookieConsentSlice.reducer,
    dashboard: dashboardSlice.reducer,
    drawer: drawerSlice.reducer,
    local: localSlice.reducer,
    modal: modalSlice.reducer,
    organisation: organisationSlice.reducer,
    user: userSlice.reducer,
  })
);

const stateSyncConfig = {
  predicate: (action: { type: string; $isSync?: boolean }) => {
    if (action.$isSync) return false;

    const allowed = ["auth/", "local/", "user/"];
    const shouldSync = allowed.some(prefix => action.type.includes(prefix));

    return shouldSync;
  },
  channel: "fg_availio_sync_channel",
};

const stateSyncMiddleware = createStateSyncMiddleware(
  stateSyncConfig
) as Middleware;

export const store = configureStore({
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(stateSyncMiddleware),
  reducer: persistedReducer,
});
initMessageListener(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const persistor = persistStore(store);
